<h1>Help</h1>

<p>Pathfinder is a simple tool for a complex task.</p>
<h3>User manual</h3>
<p>To get familiar with Pathfinder, check the <a target="_blank" href="/true/assets/pdf/PathfinderUserManual.pdf">user manual available here.</a></p>
<h3>Factsheets</h3>
<p>You can also download the factsheets upon which Pathfinder is built:</p>
<ul>
    <li><a target="_blank" href="/true/assets/pdf/Pathfinder_EnvironmentalPillarFactSheet.pdf">Environmental pillar factsheet</a></li>
    <li><a target="_blank" href="/true/assets/pdf/Pathfinder_EconomicPillarFactSheet.pdf">Economic pillar factsheet</a></li>
    <li><a target="_blank" href="/true/assets/pdf/Pathfinder_SocialPillarFactSheet.pdf">Social pillar factsheet</a></li>
    <li><a target="_blank" href="/true/assets/pdf/Pathfinder_FactSheetsCombined.pdf">Combined document with all pillars</a></li>
</ul>
<h3>Feedback</h3>
<p>Plese help us improve Pathfinder by quickly filling out the System Usability scale questionnaire available <a target="_blank" href="http://usabeu.ijs.si/questionnaire=6f54023fb11ea703dc0bde8e2322ccf624bb0aac544c63a2262190b25cf320afe2006d1066ad9b3a">here</a>. You can also send us an email at <a href="mailto:dexiware@ijs.si?subject=Pathfinder feedback">dexiware&#64;ijs.si</a>.</p>
<div class="bottomHelp">    
    <button (click)="close()">CLOSE</button>
</div>